module.exports = __webpack_public_path__ + "static/media/daily class attendance.1ef09a49.svg";